import { render, staticRenderFns } from "./indexBroker.vue?vue&type=template&id=68190866"
import script from "./indexBroker.vue?vue&type=script&lang=js"
export * from "./indexBroker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports